import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f4ef529"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = {
  class: "header-container tw-bg-white xl:tw-px-[60px] xl:tw-py-[55px] tw-px-[10px] tw-py-[20px]",
  style: {"align-items":"center","display":"flex"}
}
const _hoisted_3 = { class: "header-text" }
const _hoisted_4 = { class: "domain-content main-content tw-relative xl:tw-px-[60px] xl:tw-py-[55px] tw-px-[10px] tw-py-[10px]" }
const _hoisted_5 = { class: "tw-flex align-items-start xl:tw-flex-row tw-flex-col-reverse" }
const _hoisted_6 = {
  id: "clickbox-domain",
  class: "tw-left-sidebar org-modal-contain"
}
const _hoisted_7 = { class: "first-row tw-flex tw-w-full tw-justify-between tw-items-center" }
const _hoisted_8 = { class: "search-box tw-flex tw-justify-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/search_black_icon.svg",
  alt: "search_icon"
}, null, -1))
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "tw-flex tw-items-center bulk__action" }
const _hoisted_12 = { class: "tw-rounded-md table-size" }
const _hoisted_13 = {
  key: 0,
  class: "tw-right-sidebar skeleton-domain-sidebar"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "skeleton-radial custom-global-skeleton-pulse" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "skeleton-text-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "skeleton-percent custom-global-skeleton-pulse" }),
  /*#__PURE__*/_createElementVNode("div", { class: "skeleton-text custom-global-skeleton-pulse" })
], -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass('tw-right-sidebar bg-transparent')
}
const _hoisted_18 = { class: "number-per" }
const _hoisted_19 = { class: "text-per" }

import store from "@/store";
import { Ref, computed, onMounted, onUnmounted, ref, watch } from "vue";
import utilities, { getComponentUiText } from "@/utils/utilities";
import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import RadialProgressBar from "@/components/prospect/prospectQuestions/componentTypes/radialProgressBar.vue";
import ButtonFilter from "@/components/common/setting/buttonFilter.vue";
import DomainTable from "@/pages/domains/domainTable.vue";
import IconButton from "@/components/common/iconButton.vue";
import ButtonBulkActions from "@/components/common/setting/buttonBulkActions.vue";
import AddDomainModal from "@/components/domains/addDomainModal.vue";
import VerifyAddDomainModal from "@/components/domains/verifyAddDomainModal.vue";
import VerifyEmailModal from "@/components/domains/verifyEmailModal.vue";
import ManageDomainModal from "@/components/domains/manageDomainModal.vue";
import BrandPattern4 from "@/components/prospect/brandPattern/brandPattern4.vue";
import backgroundComponent from "@/components/common/backgroundComponent.vue";
import ActivePathWrapper from "@/components/common/activePathWrapper.vue";
import {
  deleteOrgDomains,
  getOrgDomains,
  postDeleteOrgDomain,
  postOrgDomainVerify,
  unVerifyDomain,
  unVerifyDomainEmail,
} from "@/services/org";
import { IDomain } from "@/interfaces/org/domain";
import get from "lodash/get";
import {
  ARE_YOU_SURE_TYPES,
  MODAL_NAME,
  localStorageKey,
  manageDomainActions,
} from "@/utils/constants";
import DeleteDomainModal from "@/components/domains/deleteDomainModal.vue";
import commonServices from "@/services/common/commonServices";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";
import { CustomTableColumn } from "@/components/common/customTable.vue";
import CustomDropDownItem from "@/components/common/customDropDownItem.vue";
import { IModalMessage } from "@/interfaces/common/common";


export default /*#__PURE__*/_defineComponent({
  __name: 'domainManagement',
  setup(__props) {

const tableFields: CustomTableColumn[] = [
  {
    text: getComponentUiText("app-component-custom-table-header-name-1"),
    value: "domain",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    sortable: false,
  },
  {
    text: getComponentUiText("app-component-custom-table-header-status-1"),
    value: "isVerified",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    render: (value: string) =>
      `<span class="tw-text-[#212529] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[normal]">${value}</span>`,
    sortable: false,
  },
  {
    text: getComponentUiText("app-settings-domains-table-header-date-added-1"),
    value: "fromDate",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    render: (value: string) =>
      `<span class="tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[normal]">${value}</span>`,
    sortable: false,
  },
  {
    text: "",
    value: "action",
    headerClass: "",
    valueClass: "tw-w-[45px] !tw-pr-[16px]",
  },
];

const commonService = new commonServices();
const search: Ref<string> = ref("");
const multipleSelectedDomains: Ref<IDomain[]> = ref([] as IDomain[]);
const singleSelectedDomains: Ref<IDomain> = ref({} as IDomain);
const isShowModalAddDomain: Ref<boolean> = ref(false);
const isShowModalVerifyDomain: Ref<boolean> = ref(false);
const isShowModalManageDomain: Ref<boolean> = ref(false);
const isShowModalVerifyEmail: Ref<boolean> = ref(false);
const showBulkActions: Ref<boolean> = ref(false);
const orgDomains: Ref<IDomain[]> = ref([] as IDomain[]);
const orgDomainsFiltered: Ref<IDomain[]> = ref([] as IDomain[]);
const loadingDomainsFields: Ref<boolean> = ref(true);
const orgDomainsVerify: Ref<IDomain[]> = ref([] as IDomain[]);
const isHandleMultipleSelect: Ref<boolean> = ref(false);
const itemSelectedRow: Ref<any> = ref([]);
let isDeleteModalVisible: Ref<boolean> = ref(false);
const isLoading = computed(() => store.state.Org.isLoadingOrg);
let newDomainValue: Ref<IDomain> = ref({} as IDomain);

const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);
const currentOrg = computed(() => store.state.Org.currentOrg);
const backgroundRef = ref(null);

onMounted(async () => {
  getListDomain();
  setMenuItems();
  getCurrentUser();
});

onUnmounted(() => {
  window.removeEventListener("click", () => {});
});

const getListDomain = async () => {
  try {
    const orgId = currentOrg.value?.id;
    if (!orgId) {
      return;
    }
    const res = await getOrgDomains(orgId);
    const domains = get(res, "data.data.domains", []);
    orgDomains.value = domains.map((item) => {
      return { ...item, id: item.domainId };
    });
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.getDomains);
    }
    orgDomains.value = [];
  }
};

const currentUser: any = ref(null);
const getCurrentUser = async () => {
  if (localStorage.getItem(localStorageKey.currentUserData)) {
    currentUser.value = JSON.parse(
      localStorage.getItem(localStorageKey.currentUserData) || "{}",
    );
  }
};

watch(() => currentOrg.value, getListDomain);
const getCompletedSteps = () => {
  if (orgDomainsVerify.value.length > 0) {
    return orgDomainsVerify.value.filter((item) => item.isVerified === true)
      .length;
  }
  return 0;
};

const getProgressCompelete = () => {
  const total = orgDomainsVerify.value.length;
  const complete = getCompletedSteps();
  return `${Math.round((complete / total) * 100)}%`;
};

const setMenuItems = () => {
  window.addEventListener("click", (e: any) => {
    if (!document.getElementById("clickbox-domain")?.contains(e.target)) {
      (backgroundRef as any).animation &&
        (backgroundRef as any).animation.reloadToggle();
    }
  });
};

const getUiText = (id: string, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const addDomain = () => {
  newDomainValue.value = {} as IDomain;
  isShowModalAddDomain.value = true;
};

const addDomainSuccess = (domain: IDomain) => {
  // domain response from api is not contain isVerified field.
  if (domain.isVerified === undefined) domain.isVerified = false;
  orgDomains.value = [...orgDomains.value, domain];
  newDomainValue.value = domain;
  showModalVerifyDomain();
};

const showModalVerifyDomain = () => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.VERIFY_ADD_DOMAIN,
    properties: {
      domain: newDomainValue.value,
    },
    events: {
      "update:domain": updateDomainVerified,
      "delete:domain": ($event) => deleteDomainByID($event),
    },
  };

  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const getSelectedSingleDomain = (id) => {
  if (!id) return;
  const selectedDomain = orgDomains.value.find((item) => item.domainId === id);
  if (selectedDomain) singleSelectedDomains.value = selectedDomain;
};

const getSelectedMultipleDomains = (ids: string[]) => {
  multipleSelectedDomains.value = [];
  if (!ids || ids.length === 0) multipleSelectedDomains.value = [];
  ids.forEach((id) => {
    const selectedDomain = orgDomains.value.find(
      (item) => item.domainId === id,
    );
    if (selectedDomain) multipleSelectedDomains.value.push(selectedDomain);
  });
};

const handleSelectDomain = (ids: string[]) => {
  if (ids.length < 1) {
    isShowMoreActions.value = false;
  }
  itemSelectedRow.value = ids;
  getSelectedMultipleDomains(ids);
  if (multipleSelectedDomains.value.length >= 1) {
    showBulkActions.value = true;
  } else {
    showBulkActions.value = false;
  }
};

watch(
  () => currentOrg.value,
  (newValue, oldValue) => {
    if (newValue.id && oldValue.id && newValue.id !== oldValue.id) {
      loadingDomainsFields.value = true;
      handleSelectDomain([]);
    }
  },
  { deep: true },
);

const handleVerifyDomain = async (domain: IDomain) => {
  try {
    const res = await postOrgDomainVerify(parseInt(domain.domainId) || 0);
    const isVerified = get(res, "data.data.isVerified", false);

    const emitData: IToastMessage = {
      variant: isVerified ? ToastVariant.SUCCESS : ToastVariant.ERROR,
      message: getComponentUiText(
        "app-settings-domain-verify-success-message-2",
        false,
        { domain: domain.domain },
      ),
    };

    if (!isVerified)
      emitData.message = getComponentUiText(
        "app-settings-domain-verify-error-message-1",
        false,
        { domain: domain.domain },
      );

    if (isVerified)
      updateDomainVerified({
        ...domain,
        isVerified: isVerified,
      });

    EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
  } catch (error) {
    showErrorAPI(error, Org.orgDomainVerifyCheck);
  }
};

const handleShowModalManageDomain = (id) => {
  getSelectedSingleDomain(id);
  isShowModalManageDomain.value = true;
};

// eslint-disable-next-line no-unused-vars
const deleteDomainByID = (id: string) => {
  getSelectedSingleDomain(id);
  isDeleteModalVisible.value = true;
};

const showModalSendVerificationEmail = async (domain: IDomain) => {
  isShowModalVerifyEmail.value = true;
  singleSelectedDomains.value = domain;
};

const closeModalSendVerificationEmail = () => {
  isShowModalVerifyEmail.value = false;
  singleSelectedDomains.value = {} as IDomain;
};

const deleteDomains = () => {
  if (
    !multipleSelectedDomains.value ||
    multipleSelectedDomains.value.length === 0
  )
    return;
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: getUiText(
        "app-settings-domain-bulk-actions-modal-delete-domains-title-1",
      ),
      description: getUiText(
        "app-settings-domain-bulk-actions-modal-delete-domains-description-1",
      ),
      show: true,
      list: multipleSelectedDomains.value.map((item) => item.domain),
      buttonRed: true,
      buttonText: getUiText("app-common-action-remove-title-1"),
      type: ARE_YOU_SURE_TYPES.settingDomainMultiDelete,
    },
    events: {
      "update:data": deleteMultiDomain,
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
  // }
  isHandleMultipleSelect.value = true;
};

const handleUnVerifyDomain = (item) => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: getComponentUiText(
        "app-settings-domain-bulk-actions-modal-un-verify-domains-title-1",
        false,
        {
          domainName: item.domain,
        },
      ),
      description: getUiText(
        "app-settings-domain-bulk-actions-modal-un-verify-domains-description-1",
      ),
      show: true,
      buttonRed: true,
      hiddenHelp: false,
      buttonText: getUiText("app-common-action-un-verify-title-1"),
    },
    events: {
      "update:data": async () => {
        loadingDomainsFields.value = true;
        try {
          const res = await unVerifyDomain(item.domainId);
          getListDomain();

          const emitData: IToastMessage = {
            variant: ToastVariant.SUCCESS,
            message: getUiText(
              "app-settings-domain-bulk-actions-modal-un-verify-domains-success-1",
            ),
          };
          EventEmitter.emit(
            EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE,
            emitData,
          );
        } catch (error) {
          if (error) {
            showErrorAPI(error, Org.unVerifyDomain);
          }
        } finally {
          loadingDomainsFields.value = false;
        }
      },
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const handleUnVerifyEmail = (item) => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: getComponentUiText(
        "app-settings-domain-bulk-actions-modal-un-verify-domains-title-1",
        false,
        {
          domainName: item.domain,
        },
      ),
      description: getUiText(
        "app-settings-domain-bulk-actions-modal-un-verify-domains-description-1",
      ),
      show: true,
      buttonRed: true,
      hiddenHelp: false,
      buttonText: getUiText("app-common-action-un-verify-title-1"),
    },
    events: {
      "update:data": async () => {
        loadingDomainsFields.value = true;
        try {
          const res = await unVerifyDomainEmail([Number(item.domainId)]);
          getListDomain();

          const emitData: IToastMessage = {
            variant: ToastVariant.SUCCESS,
            message: getUiText(
              "app-settings-domain-bulk-actions-modal-un-verify-emails-success-1",
            ),
          };
          EventEmitter.emit(
            EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE,
            emitData,
          );
        } catch (error) {
          if (error) {
            showErrorAPI(error, Org.unVerifyDomain);
          }
        } finally {
          loadingDomainsFields.value = false;
        }
      },
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const deleteMultiDomain = async () => {
  try {
    store.dispatch("LoadingAreYouSureButtonModal/setLoadingRedButton", true);
    await deleteOrgDomains(itemSelectedRow.value);
    getListDomain();
  } catch (error) {
    if (error) {
      const emitData: IToastMessage = {
        variant: ToastVariant.ERROR,
        message: error.data.error.message,
      };
      EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
    }
  } finally {
    store.dispatch("LoadingAreYouSureButtonModal/setLoadingRedButton", false);
  }
};

const isLoadingDelete = ref(false);
const closeDeleteModal = async () => {
  try {
    isLoadingDelete.value = true;
    commonService.setCursorLoading();
    if (isHandleMultipleSelect.value) {
      const ids = multipleSelectedDomains.value.map((d) =>
        parseInt(d.domainId),
      );
      await deleteOrgDomains(ids);
    } else {
      await postDeleteOrgDomain(singleSelectedDomains.value.domainId);
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.getDomain);
    }
  } finally {
    isHandleMultipleSelect.value = false;
    isDeleteModalVisible.value = false;
    isShowModalManageDomain.value = false;
    isShowModalAddDomain.value = false;
    isShowModalVerifyDomain.value = false;
    isLoadingDelete.value = false;
    commonService.setCursorDefault();
    getListDomain();
  }
};

const filteredData = () => {
  orgDomainsFiltered.value = orgDomains.value
    .filter((post) => {
      return post.domain.toLowerCase().includes(search.value.toLowerCase());
    })
    .map((item) => {
      return {
        ...item,
        isVerified: {
          isVerifiedDNS: item.isVerified,
          isVerifiedEmail: item.isVerifiedEmail ? true : false,
        },
      };
    });
  loadingDomainsFields.value = false;
};

const onPageCompleted = () => {
  if (!loadingDomainsFields.value && isLoading.value)
    EventEmitter.emit(EmitterEvents.PAGE_LOADING_COMPLETED);
};
watch(loadingDomainsFields, onPageCompleted);

const updateDomainVerified = (domain: IDomain) => {
  orgDomains.value = orgDomains.value.map((item) => {
    if (item.domainId === domain.domainId) return domain;
    return item;
  });
};

const watchOrgDomains = () => {
  filteredData();
  orgDomainsVerify.value = orgDomains.value;
};

const onManageDomainModalClose = (action) => {
  if (action === manageDomainActions.delete) {
    isDeleteModalVisible.value = true;
  } else {
    isShowModalManageDomain.value = false;
  }
};

watch(search, filteredData);
watch(orgDomains, watchOrgDomains);
const isShowMoreActions = ref(false);
const handleShowBulkAction = () => {
  isShowMoreActions.value = !isShowMoreActions.value;
  if (multipleSelectedDomains.value.length < 1) {
    isShowMoreActions.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppBarLayout, null, {
      default: _withCtx(({ activeHierarchy }) => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(BrandPattern4, {
            ref: "animation",
            page: "APPBARLAYOUT"
          }, null, 512),
          _createVNode(backgroundComponent, {
            ref_key: "backgroundRef",
            ref: backgroundRef
          }, null, 512),
          _createVNode(ActivePathWrapper, {
            class: "tw-px-[20px] md:tw-px-[32px] xl:tw-px-[79px]",
            "active-hierarchy": activeHierarchy
          }, null, 8, ["active-hierarchy"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(getUiText("app-settings-domain-title-text-1")), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                      type: "text",
                      placeholder: getUiText('app-table-search-prompt-text-1'),
                      class: "tw-placeholder-[#B7B7B7]"
                    }, null, 8, _hoisted_10), [
                      [_vModelText, search.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", { onClick: handleShowBulkAction }, [
                      _createVNode(ButtonBulkActions, {
                        active: showBulkActions.value,
                        "id-popover": 'popover-button-bulk-actions-domain-management',
                        class: _normalizeClass(`!tw-border tw-border-1 !tw-border-solid !tw-border-[#EFF0F1]`),
                        "show-more-actions": isShowMoreActions.value,
                        "show-acction-click": true,
                        "selected-number": multipleSelectedDomains.value.length
                      }, {
                        default: _withCtx(() => [
                          _createVNode(CustomDropDownItem, {
                            style: 'danger',
                            "id-text": 'app-common-action-remove-title-1',
                            onClick: deleteDomains
                          })
                        ]),
                        _: 1
                      }, 8, ["active", "show-more-actions", "selected-number"])
                    ]),
                    _createVNode(ButtonFilter, {
                      active: false,
                      "id-popover": 'popover-domain-management',
                      "is-margin-right": false
                    }),
                    _createVNode(IconButton, {
                      "data-cy": "add-domain-button",
                      src: "/img/plus_icon.svg",
                      onClick: addDomain
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(DomainTable, {
                    "table-data": orgDomainsFiltered.value,
                    "table-fields": tableFields,
                    loading: loadingDomainsFields.value,
                    onVerifyDomain: handleVerifyDomain,
                    onManageDomain: handleShowModalManageDomain,
                    onDelete: deleteDomainByID,
                    "onSelect:row": handleSelectDomain,
                    onUnVerifyDomain: handleUnVerifyDomain,
                    onUnVerifyEmail: handleUnVerifyEmail,
                    onSendVerificationEmail: showModalSendVerificationEmail
                  }, null, 8, ["table-data", "loading"])
                ])
              ]),
              (loadingDomainsFields.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
                : (!orgDomainsVerify.value?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: _normalizeClass([
                'tw-right-sidebar',
                orgDomainsVerify.value.length ? 'tw-bg-[#FFFFFF]' : '',
              ])
                    }, [
                      _createVNode(RadialProgressBar, {
                        class: "d-inline",
                        "total-steps": orgDomainsVerify.value.length,
                        "completed-steps": getCompletedSteps(),
                        "is-hide-progress": true,
                        "outer-stroke-color": "#48A0FF"
                      }, null, 8, ["total-steps", "completed-steps"]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(getProgressCompelete()), 1),
                        _createElementVNode("div", _hoisted_19, _toDisplayString(getUiText("app-settings-domain-progress-text-1")), 1)
                      ])
                    ], 2))
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(AddDomainModal, {
      show: isShowModalAddDomain.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => (isShowModalAddDomain.value = $event)),
      "onAdd:domain:success": addDomainSuccess
    }, null, 8, ["show"]),
    _createVNode(ManageDomainModal, {
      show: isShowModalManageDomain.value,
      domain: singleSelectedDomains.value,
      "onUpdate:show": onManageDomainModalClose,
      "onUpdate:domain": updateDomainVerified,
      "onDelete:domain": _cache[2] || (_cache[2] = ($event: any) => (deleteDomainByID($event)))
    }, null, 8, ["show", "domain"]),
    _createVNode(VerifyEmailModal, {
      show: isShowModalVerifyEmail.value,
      domain: singleSelectedDomains.value,
      "onUpdate:show": closeModalSendVerificationEmail,
      onSendMail: closeModalSendVerificationEmail
    }, null, 8, ["show", "domain"]),
    _createVNode(DeleteDomainModal, {
      show: _unref(isDeleteModalVisible),
      header: true,
      "red-btn": true,
      "header-title": "app-settings-domain-delete-domain-1",
      "is-loading-delete": isLoadingDelete.value,
      "contain-title": 
      isHandleMultipleSelect.value
        ? multipleSelectedDomains.value.map((d) => d.domain)
        : [singleSelectedDomains.value.domain]
    ,
      "contain-sub-title": "app-settings-domain-delete-modal-helper-text-a-1",
      "action-title": "app-settings-domain-delete-domain-1",
      "onUpdate:show": _cache[3] || (_cache[3] = 
      ($event) => {
        isHandleMultipleSelect.value = false;
        _isRef(isDeleteModalVisible) //@ts-ignore
 ? isDeleteModalVisible.value = $event : isDeleteModalVisible = $event;
      }
    ),
      "onUpdate:actionHandle": closeDeleteModal
    }, null, 8, ["show", "is-loading-delete", "contain-title"])
  ], 64))
}
}

})